<template>
    <div class="invcoie-forward-hover-payments-list">
      <!-- <DatePicker2
        :disabled="selectedInvoice.disabled"
        id="performance_date"
        :label="$t('performance_date')"
        :value="selectedInvoice.invoice.performance_date || ''"
        @input="onDateUpdate"
      /> -->
      <NTable
        class="invcoie-forward-hover-payments-list dbox1"
        :headers="headers"
        :items="artistPayments"
        @scrollnext="onInvoiceLineScroll"
        :config="tableConfig"
        height="170px"
        :id="'accounting-invoices-invoice_list-hover-artist_payments'"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>

            <td v-bind="tdcon('Artist')">
              <!-- <DatePicker
                :disabled="selectedInvoice.disabled"
                id="performance_date"
                :label="$t('performance_date')"
                :value="item['date']"
                @input="onDateUpdate"
              /> -->
              <span>{{item['date']}}</span>
              <!-- <TextField2
                type="text"
                :showLabel="false"
                id="text"
                class="dbox1"
                :disabled="true"
                :value="item['date']"
                :bb="'0px'"
                @change="e => onTextFieldChange(e, item)"
              /> -->
            </td>
            <td v-bind="tdcon('Recipient')">
                 <span>{{item['recipient']}}</span>
              <!-- <TextField2
                type="text"
                :showLabel="false"
                id="recipient"
                class="dbox1"
                :disabled="true"
                :value="item['recipient']"
                :bb="'0px'"
                @change="e => onTextFieldChange(e, item)"
              /> -->
            </td>
            <td v-bind="tdcon('Notes')">
                <span>{{item['notes']}}</span>
              <!-- <TextField2
                type="text"
                :showLabel="false"
                id="notes"
                class="dbox1"
                :disabled="true"
                :value="item['notes']"
                :bb="'0px'"
                @change="e => onTextFieldChange(e, item)"
              /> -->
            </td>
            <td v-bind="tdcon('amount')">
                <span>{{item['amount']}}</span>
              <!-- <TextField2
                type="text"
                :showLabel="false"
                id="amount"
                class="dbox1"
                :disabled="true"
                :value="item['amount']"
                :bb="'0px'"
                @change="e => onTextFieldChange(e, item)"
              /> -->
            </td>

         
        
          </tr>
        </template>
      </NTable>
   
    </div>
 
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import { EventHooks } from "../../../../plugins/text-field";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import { mapGetters } from "vuex";
import { parseNumber } from "../../../../utility";
import { tv } from "../../../../models/text-value.model";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { InvoiceForwardService } from "../../services/invoice-forward.service";
import TextInput from '../../../../plugins/text-field/text-input';
import DatePicker from "@plugins/text-field/date-picker";
import { createTableHeader } from '../../../../plugins/datatable';

export default {
  components: {
    NTable,
    DBox,
    DatePicker
  },
  props: {
    artistPayments: {
      required: true,
    },
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },

      tableConfig: createNTableConfig({
        headerStyle: 3
      }),
      forwardComplete:null
    };
  },
  computed: {
    // invoicelineHeaders: function () {
    //   return [
    //      { text: this.$t("Artist"), value: "Artist", f: 0.95 },
    //     { text: this.$t("Recipient"), value: "Recipient" },
    //     { text: this.$t("Notes"), value: "Notes",ta: "right" , f: 2.5},
    //     { text: this.$t("amount"), value: "amount" },
    //     { text: this.$dft.capHead(this.$t("Currency")), value: "Currency", ta: "right" },
    //     { text: this.$t("Exchange Rate"), value: "exchangerate", ta: "right",f:1.0 },
    //     { text: this.$t("EUR"), value: "EUR", f: 0.55 },
    //     { text: this.$t(""), value: "options", mw: 30 },
    
    //   ];
    // },
    headers: function () {
      return [
        createTableHeader('Date',{  f: 0.95} ),
        createTableHeader('Recipient',{ f: 1 } ),
        createTableHeader('Notes',{ ta: "right" , f: 2.5 }),
        createTableHeader('amount',{  ta: "right"}),
        
      ];
    },
    // vat_handling: function () {
    //   return this.selectedInvoice.invoice.vat_handling;
    // },
    // invoice: function () {
    //   return this.selectedInvoice?.invoice;
    // },
    // currencyTV: function () {
    //   return this.selectedInvoice.currencies.map(v => {

    //     return {text:v.currency_iso,value:v.currency_id}

    //   });
    // },
    // totalAmount:function(){
    //     let total=0.00;
    //     this.selectedInvoice.artist_payments.forEach(element=>{
    //       total+=parseFloat(element.amount)
    //     })
    //     return total
    // }
  },
  methods: {
    // onInvoiceSelectForward:function(e)
    // {
    //   const checked = e.target.checked;
    //   console.log("WERE",this.selectedInvoice)
    //   if(checked){
    //     InvoiceForwardService.postForwardCompletedFlag(this.selectedInvoice.invoice_id,1)
    //   }
    //   else
    //   {
    //     InvoiceForwardService.postForwardCompletedFlag(this.selectedInvoice.invoice_id,0)
    //   }
      
    // },
    // getInvoicelineAmount: function (invoiceline) {
    //   // return CURRENCY(parseNumber(invoiceline.qty, 1) * parseNumber(invoiceline.price, 0));
    //   return this.$dft.curr(parseNumber(invoiceline.qty, 1) * parseNumber(invoiceline.price, 0), this.selectedInvoice.invoiceCurrency.currency_iso);
    // },
    onInvoiceLineScroll: function () {},
    // onTextInputBlur: function (event, name, item) {
    //   console.log(event, name, item);
    //   this.$emit("changed", {
    //     name,
    //     value: event.target.value,
    //     item,
    //   });
    // },
    // onInvoiceLineClicked: function (item) {},
    // onVatTypechange: function (item, value) {
    //   this.$emit("changed", {
    //     name: "vat_type",
    //     value: value.value,
    //     item,
    //   });
    // },
    // // onInvoiceTextFieldValueChange: function (name, value) {
    // //   // console.log({name, value});
    // //   this.$emit("invoice_change", { name, value });
    // // },
    // onRadioChange: function (event) {
    //   const value = event.target.value;
    //   this.$emit("change_tax_deduc", { name: "vat_handling", value });
    // },
    // onDropdownChange: function (name, value) {
    //   this.$emit("change_tax_deduc", { name: "tax_type_id_deduction", value: value.value });
    // },
    // onAddInvoiceLine: async function () {
    // //        let  artist_pay=await InvoiceForwardService.getIvoiceDetails(this.selectedInvoice.invoice_id)  
    // //  console.log("RRRRRRRRR",artist_pay)
    //       //console.log("INVOICE",this.selectedInvoice)
    //   this.$emit("invoiceline_added", true);
    // },
    // onDeleteInvoiceLine: async function (item) {
    //   const confirmationResult = await confirmDelete("Invoice Line");
    //   if (confirmationResult === "OK") {
    //     this.$emit("artistpayments_deleted", item);
    //   }
    // },
    //  onDateUpdate: function ({ name, value }) {
    //   // console.log(name, value);
    //   this.$emit("changed", { name, value });
    // },
    // onTextFieldChange: function ({ name, value }, item) {
    //   console.log("WWWWWWWWWWW",{ name, value, item });

    //   if (name == "price") {
    //     value = (+value).toFixed(2);
    //   }
    //   this.$emit("changed", {
    //     name,
    //     value,
    //     item,
    //   });
    // },
    //MARK: Methods
  },
  mounted: async function () {
    // let  artist_pay=await InvoiceForwardService.getIvoiceDetails(this.selectedInvoice.invoice_id)  
   // console.log("PAY ARTIST",this.selectedInvoice.currencies)
  }
};
</script>


<style lang="scss">
.invcoie-forward-hover-payments-list{
  max-width: 800px;
  .dt-ntable {
    --ntable-height: 225px;
    background: white;
   
   

    // --ntable-th-padding: 0px 10px;

    // td {
    //   // padding: 0px;
    //   input.ntable--textfield {
    //     margin-left: -10px;
    //   }
    //   .dropdown-2 .dropdown {
    //     min-width: 0px;
    //   }
    // }
  
  

    th:nth-child(1),
    td:nth-child(1) {
      // flex: 0.35;
    }
    th:nth-child(6),
    td:nth-child(6) {
      // flex: 0.55;
    }

    td:not(:last-child) {
      
    }

    th:nth-child(3),
    td:nth-child(3) {
      // flex: 2.5;
    }
    th:nth-child(7),
    td:nth-child(7) {
      // max-width: 30px;
    }
  }
  .flex-container {
    display: flex;
    flex-direction: row;

    .forward-checkbox {
      flex: 0.8;
      display: flex;
      flex-direction: row;
      margin-left: 20px;
      .checkboxcontainer {
        max-width: 50px;
        margin-right: 10px;
      }
    }
    .total-artist {
      flex:0.1;
    }
    .artist-value {
      flex:0.1;
    }
  }
}
</style>
